const dataFaq = [
    {
        id: 1,
        title: 'Quand a lieu le défilé Far West ?',
        content: "Le Carna'dzons 2026 aura lieu le samedi 7 février 2026 à Saint-Martin. Le cortège débutera à 16h00 et défilera dans les rues du village transformées en villes du Far West. Préparez vos costumes de cowboys, cowgirls, shérifs et hors-la-loi pour une soirée inoubliable dans l'ambiance du Wild West !",
    }, 
    {
        id: 2,
        title: 'Horaires des Lunbabus ?',
        content: "00h15: Départ du LUNBABUS devant la place de fête jusqu’à la gare de Sion, en passant par les localités suivantes: Saint-Martin, Evolène, Hérémence, Vex, Sion. 3h00: Départ du LUNBABUS devant la place de fête. Saint-Martin, Evolène, Hérémence, Vex, Sion."
    },
    {
        id: 3,
        title: "L'entrée est-elle libre ?",
        content: "Oui, l'accès au Carna'dzons est entièrement gratuit ! Tous les cowboys et cowgirls sont les bienvenus pour participer à cette grande aventure du Far West. Venez nombreux en costume pour vivre pleinement l'ambiance des saloons et des ranchs du Wild West à Saint-Martin !"
    },
]

export default dataFaq;